import { Component, Input } from '@angular/core';
import { IDynamicComponent } from 'src/app/shared/models/dynamic-component-loader/IDynamicComponent.model';



@Component({
  template: `
    <div class="unit-card-confirm-dynamic-component">
        <mat-icon class="material-icons" svgIcon="card-confirm-dialog"></mat-icon>
        <div class="card-details">
          <span class="holder-name">{{data.holderName}}</span>
          <span class="card-number">Virtual debit card ••{{data.cardNumber}}</span>
        </div>
    </div>
  `,
  styles: [`.unit-card-confirm-dynamic-component{ 
        display: flex;
        align-items: center;
        gap: 40px;
        margin-bottom: 40px;
    }
    mat-icon{
        width: 60px !important;
        height: 40px !important;
    }
    .card-details{
      display: flex;
      flex-direction:column;
      gap: 4px;
    }
    .holder-name{
      font-weight:600;
      line-height: 22px;
    }
    .card-number{
      font-weight:400;
      line-height: 22px;
    }`]
})
export class UnitCardConfirmDialogContentComponent implements IDynamicComponent {
  @Input() data: any;
}